import { jsx as _jsx } from "react/jsx-runtime";
import { Tag } from '@dossierhq/design';
export function AuthKeyTag({ authKey, authKeys }) {
    const displayName = authKeys.find((it) => it.authKey === authKey)?.displayName ?? authKey;
    return _jsx(Tag, { children: displayName });
}
//# sourceMappingURL=AuthKeyTag.js.map